import OtherDocument from './OtherDocument'

export default OtherDocument
